module.exports = __webpack_public_path__ + "img/logo-dark.907a759e.svg";